import { Component } from '@angular/core';
import { takeUntil } from 'rxjs';
import { CommonService } from 'src/app/service/common.service';
import { Destroy } from 'src/app/service/destroy';

@Component({
    selector: 'app-img-slider',
    templateUrl: './img-slider.component.html',
    styleUrls: ['./img-slider.component.css'],
    viewProviders: [Destroy],
    standalone: false
})
export class ImgSliderComponent {
  banner:any =[];
  
  constructor(public commonService: CommonService, private destroy$: Destroy){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.getBannerImages();
  }

  getBannerImages() {
    this.commonService.getBanners().pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.banner = data.data;
    });
  }
}
